export const PERMISSIONS_ACTIONS = {
  fetch: {
    request: "PERMISSIONS/FETCH_REQUEST",
    success: "PERMISSIONS/FETCH_SUCCESS",
    error: "PERMISSIONS/FETCH_ERROR"
  },
  reset: "PERMISSIONS/RESET"
};
